import { Component, EventEmitter, Input, OnChanges, OnInit, Output, type SimpleChanges } from '@angular/core';
import { ButtonInduxtry } from '../../../../../utils/models/input.interface';
import { CommonModule } from '@angular/common';
import { MatMenuModule } from '@angular/material/menu';
import { MatTooltip } from '@angular/material/tooltip';
import { IconInduxtryComponent } from '../../common/icon-induxtry/icon-induxtry.component';

@Component({
  selector: 'button-induxtry',
  templateUrl: './button.component.html',
  styleUrls: ['./button.component.scss'],
  imports: [CommonModule, MatMenuModule, MatTooltip, IconInduxtryComponent],
})
export class ButtonComponent implements OnChanges, OnInit {
  @Input() buttonProperties: ButtonInduxtry;

  @Output() action: EventEmitter<any> = new EventEmitter();

  isLoading: boolean = false;

  ngOnInit(): void {
    this.updateLoadingState();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.buttonProperties?.customStyle === undefined || this.buttonProperties?.customStyle === null) {
      this.buttonProperties.customStyle = 'primary';
    }

    if(this.buttonProperties?.showLabel === undefined || this.buttonProperties?.showLabel === null ) {
      this.buttonProperties.showLabel = true;
    }

    // Atualiza o estado de loading quando buttonProperties muda
    if (changes['buttonProperties'] !== undefined) {
      this.updateLoadingState();
    }
  }

  private updateLoadingState(): void {
    this.isLoading = this.buttonProperties?.loading === true;
  }

  onButtonClicked(params: any, key?: string) {
    if (!this.isLoading) {
      this.action.emit([params, key]);
    }
  }
}
